import React from 'react';
import { Button } from './Button';
import { Icon } from './Icon';
import { useLanguage } from '../contexts/LanguageContext';
import { FANVUE_PROFILE_URL } from '../utils/fanvue';
export function ExclusiveTease() {
  const {
    t
  } = useLanguage();
  const benefits = [{
    icon: 'camera' as const,
    titleKey: 'exclusive.benefit1.title',
    descKey: 'exclusive.benefit1.desc'
  }, {
    icon: 'film' as const,
    titleKey: 'exclusive.benefit2.title',
    descKey: 'exclusive.benefit2.desc'
  }, {
    icon: 'sparkle' as const,
    titleKey: 'exclusive.benefit3.title',
    descKey: 'exclusive.benefit3.desc'
  }, {
    icon: 'heart' as const,
    titleKey: 'exclusive.benefit4.title',
    descKey: 'exclusive.benefit4.desc'
  }];
  return <section className="py-20 md:py-32 px-6 bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a] relative overflow-hidden" data-id="element-75" data-mp="1nrb07crb8wm2">
      {/* Subtle Pattern */}
      <div className="absolute inset-0 opacity-[0.02]" data-id="element-76" data-mp="1js26u906n0r1">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
        backgroundSize: '48px 48px'
      }} data-id="element-77" data-mp="1grx78et12zwb" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-78" data-mp="1ptwrdfzcak3h">
        {/* Header - Centered */}
        <div className="text-center mb-16 md:mb-20" data-id="element-79" data-mp="1us80foht8qkn">
          <div className="inline-flex items-center gap-2 bg-black/30 backdrop-blur-md border border-[#C5A028]/30 rounded-sm px-5 py-2.5 mb-6" data-id="element-80" data-mp="1zqt1fq4vzea5">
            <Icon name="crown" size={14} className="text-[#C5A028]" data-id="element-81" data-mp="23ps4t6ayz2zh" />
            <span className="text-[#C5A028] text-xs font-medium tracking-[0.2em] uppercase" data-id="element-82" data-mp="28jcu89yhyon2">
              {t('exclusive.badge')}
            </span>
          </div>

          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-white mb-5 tracking-tight leading-tight" data-id="element-83" data-mp="2igr9454rv5d9">
            {t('exclusive.title1')}
            <br data-id="element-84" data-mp="2ng3wcqzk2egd" />
            <span className="text-[#C5A028] italic" data-id="element-85" data-mp="2ndhoeq8r5wxm">
              {t('exclusive.title2')}
            </span>
          </h2>

          <p className="text-white/50 font-light max-w-2xl mx-auto leading-relaxed mb-6 text-sm md:text-base px-4" data-id="element-86" data-mp="1sslquzv91avs">
            {t('exclusive.subtitle')}
          </p>

          <div className="w-20 h-px bg-gradient-to-r from-transparent via-[#C5A028]/40 to-transparent mx-auto" data-id="element-87" data-mp="27jcio7wuc9yw" />
        </div>

        {/* Benefits Grid - Reduced Padding on Mobile */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-16 md:mb-20" data-id="element-88" data-mp="2ggd6acc3641a">
          {benefits.map((benefit, index) => <div key={index} className="group bg-white/[0.02] backdrop-blur-sm border border-white/5 rounded-sm p-8 md:p-10 hover:bg-white/[0.04] hover:border-[#C5A028]/20 transition-all duration-500 animate-slide-up" style={{
          animationDelay: `${index * 0.1}s`
        }} data-id="element-89" data-mp="2qg3wi1tm5wvk" data-mpi={index}>
              <div className="w-12 h-12 rounded-sm bg-[#C5A028]/10 flex items-center justify-center mb-5 group-hover:bg-[#C5A028]/15 transition-colors duration-300" data-id="element-90" data-mp="r4kpvtvs90p2">
                <Icon name={benefit.icon} size={22} className="text-[#C5A028]" data-id="element-91" data-mp="37py7lrd3bg7r" />
              </div>
              <h3 className="text-base md:text-lg text-white font-medium mb-2 tracking-wide" data-id="element-92" data-mp="2sypgfdtjhmsi">
                {t(benefit.titleKey)}
              </h3>
              <p className="text-white/50 font-light leading-relaxed text-sm" data-id="element-93" data-mp="2jz2gkwggkp1k">
                {t(benefit.descKey)}
              </p>
            </div>)}
        </div>

        {/* CTA - Centered, Full Width on Mobile */}
        <div className="text-center" data-id="element-94" data-mp="2a3sfcaxvwlou">
          <div className="flex justify-center" data-id="element-95" data-mp="2f0914yhm2nyr">
            <Button href={FANVUE_PROFILE_URL} variant="primary" className="w-full md:w-auto" data-id="element-96" data-mp="2f10zgh2lezsq">
              <Icon name="star" size={16} className="mr-2" data-id="element-97" data-mp="d9xn9nd21d62" />
              <span data-id="element-98" data-mp="d7be5jaimplq">{t('exclusive.cta')}</span>
            </Button>
          </div>

          <p className="text-white/30 text-xs md:text-sm mt-6 font-light px-4" data-id="element-99" data-mp="29c0rk05vjgi0">
            {t('exclusive.ctaSubtext')}
          </p>
        </div>
      </div>
    </section>;
}